import * as Raven from 'raven-js';

export class API {
  constructor(private readonly url: string) { }

  public async enroll(uuid: string): Promise<EnrollResponse> {
    const body: EnrollRequest = { booking_uuid: uuid };

    try {
      const response = await fetch(this.url + '/alaska/volunteer/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        body: JSON.stringify(body),
      });
      if (response.status === 200)
        return { tag: 'ok' };
      else if (response.status === 404 || response.status >= 500)
        Raven.captureMessage('Unexpected response status', {
          level: 'critical',
          extra: {
            path: '/alaska/volunteer/',
            booking_uuid: uuid,
            status: response.status,
          },
        });
    } catch {
      // Fallthrough
    }
    return { tag: 'unexpected-error' };
  }

  public async unsubscribe(uuid: string): Promise<UnsubscribeResponse> {
    const body: UnsubscribeRequest = { booking_uuid: uuid };

    try {
      const response = await fetch(this.url + '/alaska/unsubscribe/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        body: JSON.stringify(body),
      });
      if (response.status === 200)
        return { tag: 'ok' };
      else if (response.status === 404 || response.status >= 500)
        Raven.captureMessage('Unexpected response status', {
          level: 'critical',
          extra: {
            path: '/alaska/unsubscribe/',
            booking_uuid: uuid,
            status: response.status,
          },
        });
    } catch {
      // Fallthrough
    }
    return { tag: 'unexpected-error' };
  }
}

export interface EnrollRequest {
  readonly booking_uuid: string;
}

export interface UnsubscribeRequest {
  readonly booking_uuid: string;
}

export type EnrollResponse =
  | { readonly tag: 'ok' }
  | { readonly tag: 'unexpected-error' };

export type UnsubscribeResponse =
  | { readonly tag: 'ok' }
  | { readonly tag: 'unexpected-error' };



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/api/api.ts